/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

const useMyForm = ({ form = {}, validationSchema, api }) => {
  const {
    register,
    handleSubmit,
    reset,
    errors,
    control,
    getValues,
    setValue,
    formState,
    watch
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues: form
  });
  const exec = useCallback(
    (...args) => api(...args),
    [api],
  );

  const onSubmit = useCallback(handleSubmit(formData => exec(formData)), [
    handleSubmit,
    exec
  ]);
  return {
    exec,
    register,
    control,
    getValues,
    formState,
    onSubmit,
    errors,
    reset,
    setValue,
    watch
  };
};

useMyForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  validationSchema: PropTypes.any,
  api: PropTypes.func.isRequired
};

export default useMyForm;
